import { render, staticRenderFns } from "./LegalMessage.vue?vue&type=template&id=017d6d78&scoped=true&"
import script from "./LegalMessage.vue?vue&type=script&lang=js&"
export * from "./LegalMessage.vue?vue&type=script&lang=js&"
import style0 from "./LegalMessage.vue?vue&type=style&index=0&id=017d6d78&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017d6d78",
  null
  
)

export default component.exports